import $ from "jquery";
import Swiper, { Navigation, Pagination } from 'swiper';

const gallery = () => {
  const init = () => {
    swiperSlider();
    closeModal();
  };

  const swiperSlider = () => {
    $(() => {
      const el = {
        swiperModal: ".js-ModalGallery-swiper",
        swiper: ".js-Gallery-swiper",
        swiperMobile: ".js-MobileGallery-swiper",
        button: ".js-button-gallery",
        image: ".js-Gallery-swiper img, .js-MobileGallery-swiper img",
        modal: ".mi-ModalGallery",
        t_header: "#top-header",
        callButton: "#callnowbutton",
        m_header: "#main-header",
        body: "body.single"
      };

      // ----- swiper modal --------
      const swiperModal = new Swiper(el.swiperModal, {
        // Optional parameters
        modules: [Navigation],
        direction: 'horizontal',
        speed: 1000,
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 30,
        setWrapperSize: true,
        wrapperClass: 'swiper-wrapper-modal',
        loop: true,
        a11y: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // on: {
        //   click() {
        //       console.log('index', this.clickedIndex);
        //       swiperMobile.slideTo(this.clickedIndex);    
        //       swiperDesktop.slideTo(this.clickedIndex);    
        //   },
        // },
      });

      // ----- swiper mobile --------
      // const swiperMobile = new Swiper(el.swiperMobile, {
      //   // Optional parameters
      //   modules: [Pagination],
      //   direction: 'horizontal',
      //   speed: 1000,
      //   slidesPerView: 1,
      //   spaceBetween: 30,
      //   setWrapperSize: true,
      //   loop: true,
      //   wrapperClass: 'swiper-wrapper-mobile',
      //   pagination: {
      //     el: '.swiper-pagination',
      //     dynamicBullets: true,
      //     dynamicMainBullets: 1,
      //   },
      //   a11y: false,
      //   on: {
      //     click() {
      //       console.log('index', this.clickedIndex);
      //       swiperDesktop[1].slideTo(this.clickedIndex);
      //       swiperModal.slideTo(this.clickedIndex);
      //     },
      //     slideChange() {
      //       console.log('index', this.realIndex);
      //       swiperDesktop[1].slideTo(this.realIndex);
      //       swiperModal.slideTo(this.realIndex);
      //     }
      //   },
      // });

      // ----- swiper desktop --------
      const swiperDesktop = new Swiper(el.swiper, {
        // Optional parameters
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 30,
        setWrapperSize: true,
        loop: true,
        wrapperClass: 'swiper-wrapper-desktop',
        navigation: {
          nextEl: '.swiper-button-next-gallery',
          prevEl: '.swiper-button-prev-gallery',
          enabled: false,
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          dynamicMainBullets: 1,
          enabled: true,
        },
        a11y: false,
        breakpoints: {
          1025: {
            pagination: {
              enabled: false,
            },
            navigation: {
              enabled: true,
            },
          }
        },
        on: {
          // click() {
          //   console.log('index', this.clickedIndex);
          //   // swiperMobile[1].slideTo(this.clickedIndex);
          //   swiperModal.slideTo(this.clickedIndex);
          // },
          slideChange() {
            console.log('index', this.realIndex);
            // swiperMobile[1].slideTo(this.realIndex);
            swiperModal.slideTo(this.realIndex);
          }
        },
      });
      // eslint-disable-next-line no-console
      console.log(swiperDesktop.activeIndex);

      // handle to open modal
      $(el.image).on("click", function () {
        // // eslint-disable-next-line no-console
        // console.log(swiperDesktop[1].activeIndex);
        // // console.log($(this));
        // if ($(this).is('.mi-CaravanGallery__Item.swiper-slide-active')) {

        //   // if($(this).hasClass('swiper-slide-active'))
        //   let data = $(this).attr("id");
        //   let idImage = data.split("-");
        //   let parsedId = parseInt(idImage[1]);

        //   // eslint-disable-next-line no-console
        //   console.log(parsedId);

        //   // swiperMobile[1].slideTo(parsedId, 0)
        //   swiperModal.slideTo(parsedId, 0)

        // }
        // else if ($(this).is('mi-CaravanGallery--mobile__Item.swiper-slide-active')) {
        //   let data = $(this).attr("id");
        //   let idImage = data.split("-");
        //   let parsedId = parseInt(idImage[1]);

        //   // eslint-disable-next-line no-console
        //   console.log(parsedId);

        //   swiperDesktop[1].slideTo(parsedId, 0)
        //   swiperModal.slideTo(parsedId, 0)
        // }

        if ($(this).siblings('div.containerSwiper').children().children().is('.swiper-slide-active')) {
          let data = $(this).siblings('div.containerSwiper').find('img.mi-CaravanGallery__Item.swiper-slide-active').attr("id");
          let idImage = data.split("-");
          let parsedId = parseInt(idImage[1]);

          // eslint-disable-next-line no-console
          console.log(swiperDesktop, swiperModal);

          // swiperMobile[1].slideTo(parsedId, 0)
          swiperModal.slideTo(parsedId, 0)
        }

        $(el.modal).removeClass("closed");
        // $(el.t_header).css('z-index', '1');
        // $(el.m_header).css('z-index', '1');
        // $(el.callButton).css('z-index', '0');
        // $(el.body).css({
        //   'overflow': 'hidden',
        //   'height': '90vh'
        // });
        $(el.t_header).addClass("no-zindex");
        $(el.m_header).addClass("no-zindex");
        $(el.callButton).addClass("no-zindex");
        $(el.body).addClass("no-overflow");
      });

      $(el.button).on("click", function () {
        if ($(this).hasClass('button-gallery-desktop')) {
          if ($(this).siblings('div.containerSwiper').children().children().is('.swiper-slide-active')) {
            let data = $(this).siblings('div.containerSwiper').find('img.mi-CaravanGallery__Item.swiper-slide-active').attr("id");
            let idImage = data.split("-");
            let parsedId = parseInt(idImage[1]);

            // eslint-disable-next-line no-console
            console.log(swiperDesktop, swiperModal);

            // swiperMobile[1].slideTo(parsedId, 0)
            swiperModal.slideTo(parsedId, 0)
          }
        }

        $(el.modal).removeClass("closed");
        // $(el.t_header).css('z-index', '1');
        // $(el.m_header).css('z-index', '1');
        // $(el.callButton).css('z-index', '0');
        // $(el.body).css({
        //   'overflow': 'hidden',
        //   'height': '90vh'
        // });
        $(el.t_header).addClass("no-zindex");
        $(el.m_header).addClass("no-zindex");
        $(el.callButton).addClass("no-zindex");
        $(el.body).addClass("no-overflow");
      })
    })


  };

  const closeModal = () => {
    const el = {
      closeButton: ".close.cursor",
      modal: ".mi-ModalGallery",
      t_header: "#top-header",
      m_header: "#main-header",
      callButton: "#callnowbutton",
      body: "body.single"
    };

    $(el.closeButton).on("click", () => {
      $(el.modal).addClass("closed");
      $(el.t_header).removeClass('no-zindex');
      $(el.m_header).removeClass('no-zindex');
      $(el.body).removeClass('no-overflow');
    });
  }

  // const mobileGallerySlider = () => {
  //   const el = {
  //     swiper: ".js-MobileGallery-swiper",
  //   };

  //   new Swiper(el.swiper, {
  //     // Optional parameters
  //     modules: [Pagination],
  //     direction: 'horizontal',
  //     speed: 1000,
  //     slidesPerView: 1,
  //     spaceBetween: 30,
  //     setWrapperSize: true,

  //     pagination: {
  //       el: '.swiper-pagination-mobile',
  //       clickable: true,
  //       dynamicBullets: true,
  //     },
  //   });
  // }

  init();
};

try {
  gallery();
} catch (e) {
  console.error(e);
}
